import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { WorkOrdersKpiDashboard } from './components/WorkOrdersKpiDashboard';
import { WorkOrdersModulesGrid } from './components/WorkOrdersModulesGrid';
import { RecentWorkOrderActivity } from './components/RecentWorkOrderActivity';

export function WorkOrdersDashboardPage() {
  return (
    <PageLayout
      title="Lệnh làm việc (Work Orders)"
      description="Trung tâm điều phối, giao việc và theo dõi tiến độ thi công ngoài công trường"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <WorkOrdersKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Vận hành Khối lượng (Operations)
              </h3>
            </div>
            <div className="flex-1">
              <WorkOrdersModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Sự kiện gần đây
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentWorkOrderActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default WorkOrdersDashboardPage;
